module.exports = __webpack_public_path__ + "footer-1-13a019dec706576b4a604b5ce9959d85.png";